import telegramAnalytics from '@telegram-apps/analytics';
import { getTelegramAnalyticsConfig } from '../config/telegramAnalytics';
import { debugLog } from './logger';

let isInitialized = false;

/**
 * Initialize Telegram Analytics SDK
 * This should be called before the app starts rendering
 */
export const initializeTelegramAnalytics = (): boolean => {
  if (isInitialized) {
    debugLog('Telegram Analytics is already initialized');
    return true;
  }

  const config = getTelegramAnalyticsConfig();
  
  if (!config) {
    debugLog('Telegram Analytics initialization skipped - configuration not available');
    return false;
  }

  try {
    telegramAnalytics.init({
      token: config.token,
      appName: config.appName,
    });
    
    isInitialized = true;
    debugLog('Telegram Analytics initialized successfully');
    return true;
  } catch (error) {
    console.error('Failed to initialize Telegram Analytics:', error);
    return false;
  }
};

/**
 * Check if Telegram Analytics is initialized
 */
export const isTelegramAnalyticsInitialized = (): boolean => {
  return isInitialized;
};

/**
 * Get the Telegram Analytics instance
 * Returns null if not initialized
 */
export const getTelegramAnalytics = () => {
  if (!isInitialized) {
    debugLog('Telegram Analytics not initialized. Call initializeTelegramAnalytics() first.');
    return null;
  }
  return telegramAnalytics;
}; 